import React, { useState, Fragment, useEffect } from "react";
// import BasicPagination from "../../../../Pagination/Pagination";
import { Table, Image, Button } from "react-bootstrap";
//import BasicPagination from "../../../../Pagination/Pagination";
import moment from "moment";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";

function VideoContentPageComponent(props) {
  //state
  const [insidePageTab, setInsidePageTab] = useState("1");

  const pageChangeButtonClickHandler = (value) => (e) => {
    setInsidePageTab(value);
  };

  let filteredData = props.data;

  if (props.search) {
    filteredData = filteredData.filter((item) => {
      return (
        item &&
        item.restaurant_id &&
        item.restaurant_id.restaurant_name &&
        item.restaurant_id.restaurant_name
          .toLowerCase()
          .includes(props.search.toLowerCase())
      );
    });
  }

  if (props.sortBy === "Latest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  } else if (props.sortBy === "Oldest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
  } else if (props.sortBy === "A-Z") {
    filteredData = filteredData?.sort((a, b) =>
      a.restaurant_id?.restaurant_name > b.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  } else if (props.sortBy === "Z-A") {
    filteredData = filteredData?.sort((a, b) =>
      b.restaurant_id?.restaurant_name > a.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }

  // if (props.sortByDay !== 4) {
  //   filteredData = filteredData.filter((item) => {
  //     return (
  //       (props.startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
  //         props.startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
  //       (moment(item.createdAt).format("YYYY-MM-DD") <= props.endDay ||
  //         moment(item.updatedAt).format("YYYY-MM-DD") <= props.endDay)
  //     );
  //   });
  // }

  // if (props.startDate && props.endDate && props.clickedSearch) {
  //   let ed = new Date(props.endDate).getTime();
  //   let sd = new Date(props.startDate).getTime();

  //   filteredData = filteredData.filter((d) => {
  //     var time = new Date(d.createdAt).getTime();
  //     return sd < time && time < ed;
  //   });
  // }

  // useEffect(() => {
  //   // console.log(props.data);
  //   if (props.data) {
  //     let sortedDates = [];

  //     if (props.sortByDate === 1) {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(b.updatedAt) - new Date(a.updatedAt);
  //       });
  //     } else {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(a.updatedAt) - new Date(b.updatedAt);
  //       });
  //     }
  //     setVideo(sortedDates);
  //   }
  // }, [props.data, props.sortByDate]);

  return (
    <>
      <div className="row super_admin_all_users_toggle_button-tab">
        <div className="col-9 super_admin_all_users_toggle_button-tab">
          <div className="Right-side-heading-text ml-0">
            <div className="d-flex align-items-center">
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "1" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("1")}
              >
                Restaurants
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "2" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("2")}
              >
                Offers
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "3" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("3")}
              >
                Experience
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "4" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("4")}
              >
                Items
              </Button>
            </div>
          </div>
        </div>
      </div>
      {insidePageTab === "1" && <Restaurants data={filteredData} />}
      {insidePageTab === "2" && <Offers data={filteredData} />}
      {insidePageTab === "3" && <Events data={filteredData} />}
      {insidePageTab === "4" && <Items data={filteredData} />}

      {/* {filteredData.length !== 0 ? (*/}
      {/* <BasicPagination
        totalRecords={10}
        limit={10}
        batch={5}
        onBatchChange={(e) => {}}
      /> */}
      {/*) : (
        <></>
      )} */}
    </>
  );
}

export default VideoContentPageComponent;

const Restaurants = (props) => {
  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "25%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "75%" }} className="f12-700">
              Viewed
            </th>
          </tr>
        </thead>
        {props.data.map((video, index) => (
          <Fragment key={index}>
            {video.type === 0 ? (
              <tbody className="HideShowTable">
                {/* {filteredData.slice(start, end).map((item, index) => ( */}
                <tr
                  className="super_admin_all_users_table_body super_admin_user_view_inside_table_body"
                  //   key={index}
                >
                  <td style={{ width: "25%" }}>
                    <div className="d-flex flex-column align-items-start">
                      <div className="enImage45 ">
                        <Image
                          // src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                          src={
                            (video &&
                              video.restaurant_id &&
                              video.restaurant_id.logo_url) ||
                            NOTAVAILABLEIMAGE
                          }
                          //   src={item.icon}
                          alt="View"
                          title="View"
                          fluid
                        />
                      </div>
                      <div className="f11-500 text-center mt-1">
                        {" "}
                        {video &&
                          video.restaurant_id &&
                          video.restaurant_id.restaurant_name}{" "}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "75%" }}>
                    <div className="f15-700">{video.videoViewed}</div>
                    <div className="f15-700">
                      {moment(video.createdAt).format("DD MMM,YYYY")}
                      <br />
                      {moment(video.createdAt).format("LT")}
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <> </>
            )}
          </Fragment>
        ))}
      </Table>
    </div>
  );
};

const Offers = (props) => {
  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "20%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "25%" }} className="f12-700">
              Offers
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Viewed
            </th>
            {/* <th style={{ width: "15%" }} className="f12-700">
              Offers
              <br />
              Availed
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Offer Code
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Offer Start
              <br />
              End Date
            </th> */}
          </tr>
        </thead>
        {/* {props.allOffers.slice(start, end).map((offer, index) => ( */}
        {props.data.map((data, index) => (
          <Fragment key={index}>
            {data.type === 1 ? (
              <tbody className="HideShowTable">
                <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
                  <td style={{ width: "20%" }}>
                    <div className="d-flex flex-column align-items-start">
                      <div className="enImage45 ">
                        <Image
                          // src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                          src={
                            (data &&
                              data.restaurant_id &&
                              data.restaurant_id.logo_url) ||
                            NOTAVAILABLEIMAGE
                          }
                          alt="Restaurant logo"
                          title="Restaurant logo"
                          fluid
                        />
                      </div>
                      <div className="f11-500 text-center mt-1">
                        {data &&
                          data.restaurant_id &&
                          data.restaurant_id.restaurant_name}{" "}
                        {/* {offer &&
           offer.restaurant_id &&
           offer.restaurant_id.restaurant_name} */}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="d-flex align-items-center">
                      <div className="text-center d-flex flex-column align-items-center">
                        <div className="enIMG62">
                          {/* {offer.photos[0] ? ( */}
                          <Image
                            src={require("../../../../../assets/images/UserManagement/offer.png")}
                            // src={offer.photos[0]}
                            alt="Offer img"
                            title="Offer img"
                            fluid
                          />
                          {/* ) : (
             <Image
               src={require("../../../../../assets/images/UserManagement/offer.png")}
               alt="Offer img"
               title="Offer img"
               fluid
             />
           )} */}
                        </div>
                        <div className="enPendingLBL mt-2">Offline</div>
                      </div>
                      <div className="pl-3">
                        {/* <div className="f12-500">{offer.name}</div> */}
                        Buy 1 Get 1 Free
                        <div className="f10-500 opacity5">
                          Avail Offer on All Items
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f14-500">
                      Yes
                      {/* {offer.offerViews >= 1 ? <> Yes</> : <>No </>} */}
                    </div>
                    {/* {offer.offerUsedBy && offer.offerUsedBy[0].timestamp ? (
       <>
         <div className="f9-400">
           {" "}
           {moment(offer.offerUsedBy[0].timestamp).format(
             "DD-MM-YYYY"
           )}
         </div>
         <div className="f9-400">
           {moment(offer.offerUsedBy[0].timestamp).format("LT")}
         </div>
       </>
     ) : (
       <> </>
     )} */}
                    <div className="f9-400">25th Aug, 2020</div>
                    <div className="f9-400">12:30 PM</div>
                  </td>
                  {/* <td style={{ width: "15%" }}>
     <div className="f14-500">
       Yes */}
                  {/* {offer.offerUsed >= 1 ? <> Yes</> : <>No </>} */}
                  {/* </div> */}
                  {/* {offer.offerUsedBy && offer.offerUsedBy[0].timestamp ? (
       <>
         <div className="f9-400">
           {" "}
           {moment(offer.offerUsedBy[0].timestamp).format(
             "DD-MM-YYYY"
           )}
         </div>
         <div className="f9-400">
           {moment(offer.offerUsedBy[0].timestamp).format("LT")}
         </div>
       </>
     ) : (
       <> </>
     )} */}
                  {/* <div className="f9-400">25th Aug, 2020</div>
     <div className="f9-400">12:30 PM</div>
   </td>
   <td style={{ width: "10%" }}>
     ASCFGFML12 */}
                  {/* <div className="f14-500">{offer.coupon_code}</div> */}
                  {/* </td>
   <td style={{ width: "15%" }}>
     <div className="f14-400">
       25th Feb 20 - */}
                  {/* {moment(offer.start_date).format("Do MMM  YY")}- */}
                  {/* </div>
     <div className="f14-400 text-red">
       25th Mar 20 */}
                  {/* {moment(offer.end_date).format("Do MMM  YY")} */}
                  {/* </div>
   </td> */}
                </tr>
              </tbody>
            ) : (
              <> </>
            )}
          </Fragment>
        ))}

        {/* // ))} */}
      </Table>
    </div>
  );
};

const Events = (props) => {
  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "20%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "25%" }} className="f12-700">
            Experience
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Viewed
            </th>
            {/* <th style={{ width: "15%" }} className="f12-700">
              Offers
              <br />
              Availed
            </th>
            <th style={{ width: "10%" }} className="f12-700">
              Offer Code
            </th>
            <th style={{ width: "15%" }} className="f12-700">
              Offer Start
              <br />
              End Date
            </th> */}
          </tr>
        </thead>
        {/* {props.allOffers.slice(start, end).map((offer, index) => ( */}
        {props.data.map((data, index) => (
          <Fragment key={index}>
            {data.type === 2 ? (
              <tbody className="HideShowTable">
                <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
                  <td style={{ width: "20%" }}>
                    <div className="d-flex flex-column align-items-start">
                      <div className="enImage45 ">
                        <Image
                          //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                          src={
                            (data &&
                              data.restaurant_id &&
                              data.restaurant_id.logo_url) ||
                            NOTAVAILABLEIMAGE
                          }
                          alt="Restaurant logo"
                          title="Restaurant logo"
                          fluid
                        />
                      </div>
                      <div className="f11-500 text-center mt-1">
                        {data &&
                          data.restaurant_id &&
                          data.restaurant_id.restaurant_name}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="d-flex align-items-center">
                      <div className="text-center d-flex flex-column align-items-center">
                        <div className="enIMG62">
                          {/* {offer.photos[0] ? ( */}
                          <Image
                            //src={require("../../../../../assets/images/UserManagement/offer.png")}
                            src={
                              data &&
                              data.event_id &&
                              data.event_id.photos &&
                              data.event_id.photos[0]
                            }
                            // src={offer.photos[0]}
                            alt="Offer img"
                            title="Offer img"
                            fluid
                          />
                          {/* ) : (
             <Image
               src={require("../../../../../assets/images/UserManagement/offer.png")}
               alt="Offer img"
               title="Offer img"
               fluid
             />
           )} */}
                        </div>
                        <div className="enPendingLBL mt-2">
                          {data && data.event_id && data.event_id.isOnline
                            ? "Online"
                            : "Offline"}
                        </div>
                      </div>
                      <div className="pl-3">
                        {/* <div className="f12-500">{offer.name}</div> */}
                        {data && data.event_id && data.event_id.name}
                        <div className="f10-500 opacity5">
                          {data && data.event_id && data.event_id.description}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="f14-500">
                      {data.videoViewed ? "Yes" : "No"}
                      {/* {offer.offerViews >= 1 ? <> Yes</> : <>No </>} */}
                    </div>
                    {/* {offer.offerUsedBy && offer.offerUsedBy[0].timestamp ? (
       <>
         <div className="f9-400">
           {" "}
           {moment(offer.offerUsedBy[0].timestamp).format(
             "DD-MM-YYYY"
           )}
         </div>
         <div className="f9-400">
           {moment(offer.offerUsedBy[0].timestamp).format("LT")}
         </div>
       </>
     ) : (
       <> </>
     )} */}
                    <div className="f9-400">
                      {moment(data.createdAt).format("DD MMM,YYYY")}
                    </div>
                    <div className="f9-400">
                      {moment(data.createdAt).format("LT")}
                    </div>
                  </td>
                  {/* <td style={{ width: "15%" }}>
     <div className="f14-500">
       Yes */}
                  {/* {offer.offerUsed >= 1 ? <> Yes</> : <>No </>} */}
                  {/* </div> */}
                  {/* {offer.offerUsedBy && offer.offerUsedBy[0].timestamp ? (
       <>
         <div className="f9-400">
           {" "}
           {moment(offer.offerUsedBy[0].timestamp).format(
             "DD-MM-YYYY"
           )}
         </div>
         <div className="f9-400">
           {moment(offer.offerUsedBy[0].timestamp).format("LT")}
         </div>
       </>
     ) : (
       <> </>
     )} */}
                  {/* <div className="f9-400">25th Aug, 2020</div>
     <div className="f9-400">12:30 PM</div>
   </td>
   <td style={{ width: "10%" }}>
     ASCFGFML12 */}
                  {/* <div className="f14-500">{offer.coupon_code}</div> */}
                  {/* </td>
   <td style={{ width: "15%" }}>
     <div className="f14-400">
       25th Feb 20 - */}
                  {/* {moment(offer.start_date).format("Do MMM  YY")}- */}
                  {/* </div>
     <div className="f14-400 text-red">
       25th Mar 20 */}
                  {/* {moment(offer.end_date).format("Do MMM  YY")} */}
                  {/* </div>
   </td> */}
                </tr>
              </tbody>
            ) : (
              <> </>
            )}
          </Fragment>
        ))}

        {/* // ))} */}
      </Table>
    </div>
  );
};

const Items = (props) => {
  return (
    <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
      <Table className="enMinWidth900">
        <thead>
          <tr className="super_admin_all_users_table_head">
            <th style={{ width: "20%" }} className="f12-700">
              Restaurant
              <br />
              Name
            </th>
            <th style={{ width: "25%" }} className="f12-700">
              Item Name
            </th>
            <th style={{ width: "25%" }} className="f12-700">
              Viewed
            </th>
            {/* <th style={{ width: "30%" }} className="f12-700">
              Ordered
            </th> */}
          </tr>
        </thead>
        {/* {props.allOffers.slice(start, end).map((offer, index) => ( */}
        {props.data.map((item, index) => (
          <Fragment key={index}>
            {item.type === 3 ? (
              <tbody className="HideShowTable">
                <tr className="super_admin_all_users_table_body super_admin_user_view_inside_table_body">
                  <td style={{ width: "20%" }}>
                    <div className="d-flex flex-column align-items-start">
                      <div className="enImage45 ">
                        <Image
                          src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                          src={
                            (item &&
                              item.restaurant_id &&
                              item.restaurant_id.logo_url) ||
                            NOTAVAILABLEIMAGE
                          }
                          alt="Restaurant logo"
                          title="Restaurant logo"
                          fluid
                        />
                      </div>
                      <div className="f11-500 text-center mt-1">
                        {item &&
                          item.restaurant_id &&
                          item.restaurant_id.restaurant_name}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="d-flex align-items-center">
                      <div className="text-center d-flex flex-column align-items-center">
                        <div className="enIMG62">
                          {/* {offer.photos[0] ? ( */}
                          <Image
                            src={require("../../../../../assets/images/UserManagement/offer.png")}
                            // src={offer.photos[0]}
                            alt="Offer img"
                            title="Offer img"
                            fluid
                          />
                          {/* ) : (
                      <Image
                        src={require("../../../../../assets/images/UserManagement/offer.png")}
                        alt="Offer img"
                        title="Offer img"
                        fluid
                      />
                    )} */}
                        </div>
                        {/* <div className="enPendingLBL mt-2">Offline</div> */}
                      </div>
                      <div className="pl-3">
                        {/* <div className="f12-500">{offer.name}</div> */}
                        Spaghetti Formaggi
                        {/* <div className="f10-500 opacity5">
                    Avail Offer on All Items
                  </div> */}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "25%" }}>
                    <div className="f14-500">
                      Yes
                      {/* {offer.offerViews >= 1 ? <> Yes</> : <>No </>} */}
                    </div>
                    {/* {offer.offerUsedBy && offer.offerUsedBy[0].timestamp ? (
                <>
                  <div className="f9-400">
                    {" "}
                    {moment(offer.offerUsedBy[0].timestamp).format(
                      "DD-MM-YYYY"
                    )}
                  </div>
                  <div className="f9-400">
                    {moment(offer.offerUsedBy[0].timestamp).format("LT")}
                  </div>
                </>
              ) : (
                <> </>
              )} */}
                    <div className="f9-400">25th Aug, 2020</div>
                    <div className="f9-400">12:30 PM</div>
                  </td>
                  {/* <td style={{ width: "30%" }}>
              <div className="f14-500">
                Yes */}
                  {/* {offer.offerUsed >= 1 ? <> Yes</> : <>No </>} */}
                  {/* </div> */}
                  {/* {offer.offerUsedBy && offer.offerUsedBy[0].timestamp ? (
                <>
                  <div className="f9-400">
                    {" "}
                    {moment(offer.offerUsedBy[0].timestamp).format(
                      "DD-MM-YYYY"
                    )}
                  </div>
                  <div className="f9-400">
                    {moment(offer.offerUsedBy[0].timestamp).format("LT")}
                  </div>
                </>
              ) : (
                <> </>
              )} */}
                  {/* <div className="f9-400">25th Aug, 2020</div>
              <div className="f9-400">12:30 PM</div>
            </td> */}
                </tr>
              </tbody>
            ) : (
              <> </>
            )}
          </Fragment>
        ))}

        {/* // ))} */}
      </Table>
    </div>
  );
};
